import { CONTRACTOR_DETAIL_TAB_VALUES } from "@dune/types";
import { parseAsString, useQueryState } from "nuqs";
import { useGetContractorById } from "../../../api/queries/contractors.queries";
import { GoBackButton } from "../../../component/common/GoBackButton";
import PageLayoutWithTabs, {
	Tab,
} from "../../../component/layout/PageLayoutWithTabs";
import { useDocumentSelection } from "../../../hooks/panel-sync/useDocumentSelection";
import { useRequiredParams } from "../../../hooks/useRequiredParams";
import CertificateTab from "./components/tabs/CertificateTab";
import ConstructionTab from "./components/tabs/ConstructionTab";
import InformationsTab from "./components/tabs/InformationsTab";

export default function ContractorDetailsPage() {
	const { id } = useRequiredParams<{ id: string }>();
	const {
		data: contractor,
		isLoading,
		error,
	} = useGetContractorById(Number(id));

	useDocumentSelection({
		entityType: "CONSTRUCTION_SITE",
		entityId: Number(id),
	});

	const tabs: Tab[] = [
		{ value: CONTRACTOR_DETAIL_TAB_VALUES.INFORMATIONS, label: "Informations" },
		{ value: CONTRACTOR_DETAIL_TAB_VALUES.ATTESTATIONS, label: "Attestations" },
		{ value: CONTRACTOR_DETAIL_TAB_VALUES.CHANTIERS, label: "Chantiers" },
	];

	const [activeTab, setActiveTab] = useQueryState(
		"tab",
		parseAsString.withDefault(CONTRACTOR_DETAIL_TAB_VALUES.INFORMATIONS),
	);

	if (isLoading) {
		return <div>Chargement...</div>;
	}

	if (error || !contractor) {
		return <div>Erreur lors du chargement des données</div>;
	}

	const title = (
		<div className="flex flex-col gap-2">
			<span>
				{contractor.society?.denomination ||
					contractor.foreignSociety?.denomination ||
					"Intervenant"}
			</span>
		</div>
	);

	const tabContent: { [key: string]: React.ReactNode } = {
		[CONTRACTOR_DETAIL_TAB_VALUES.INFORMATIONS]: (
			<InformationsTab contractor={contractor} />
		),
		[CONTRACTOR_DETAIL_TAB_VALUES.ATTESTATIONS]: (
			<CertificateTab
				certificates={contractor.decennialCertificates ?? []}
				contractorId={contractor.id}
			/>
		),
		[CONTRACTOR_DETAIL_TAB_VALUES.CHANTIERS]: (
			<ConstructionTab
				constructionSites={
					contractor.participantToConstructionSiteSubmission ?? []
				}
			/>
		),
	};

	return (
		<PageLayoutWithTabs
			title={title}
			tabs={tabs}
			activeTab={activeTab}
			onTabChange={setActiveTab}
			tabContent={tabContent}
			topActions={
				<div className="flex flex-row gap-2">
					<GoBackButton />
				</div>
			}
		/>
	);
}
